import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import LoadingBackdrop from "../../template/components/LoadingBackdrop";
import { ClippingBox, ClippingBoxProps } from "./ClippingBox";
import { useCameraClips } from "./hooks/useCameraClips";

type ClipDialogProps = {
  open: boolean;
};

export const ClipDialog = ({
  open,
  ...rest
}: ClippingBoxProps & ClipDialogProps): JSX.Element => {
  const { t } = useTranslation();
  const { onClose, cameraId } = rest;
  const { saveCamClipAsync, clipCreationLoading } = useCameraClips({
    cameraId,
  });
  return (
    <Dialog maxWidth="xl" open={open} onClose={onClose}>
      <LoadingBackdrop
        open={clipCreationLoading}
        text={t("clips:creatingClip")}
      />
      <DialogTitle>{t("clips:createNew")}</DialogTitle>
      <DialogContent>
        <ClippingBox {...rest} saveCamClipAsync={saveCamClipAsync} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          {t("general:cancel")}
        </Button>
        <Button
          color="info"
          type="submit"
          form="create-clip-form"
          variant="contained"
        >
          {t("general:create")}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
